export const CHANGE_NUMBER_OF_AS2_REQUESTS = 'CHANGE_NUMBER_OF_AS2_REQUESTS';
export const CHANGE_NUMBER_OF_SFTP_REQUESTS = 'CHANGE_NUMBER_OF_SFTP_REQUESTS';
export const CHANGE_NUMBER_OF_PARTNER_SFTP_REQUESTS = 'CHANGE_NUMBER_OF_PARTNER_SFTP_REQUESTS';
export const TOGGLE_NONDEPLOYED_VERSIONS = 'TOGGLE_NONDEPLOYED_VERSIONS';
export const RECEIVE_NONDEPLOYED_VERSIONS = 'RECEIVE_NONDEPLOYED_VERSIONS';
export const REQUEST_NONDEPLOYED_VERSIONS_FAILED = 'REQUEST_NONDEPLOYED_VERSIONS_FAILED';
export const RECEIVE_VERSION_DATA = 'RECEIVE_VERSION_DATA';
export const REQUEST_VERSION_DATA_FAILED = 'REQUEST_VERSION_DATA_FAILED';
export const RESET_STATE = 'RESET_STATE';
